@if (deploy) {
  <div id="content">
    <div class="page-title">
      <button mat-flat-button [routerLink]="['../']">
        <mat-icon matPrefix>arrow_back</mat-icon>
        Volver
      </button>
      <h1>{{ page_title }}</h1>
    </div>

    <mat-card>
      <mat-card-header>
        <mat-card-title>Información del Deploy</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="deploy-info">
          <div class="info-row">
            <strong>Producto:</strong>
            <span>{{ deploy.company_product?.title }}</span>
          </div>
          <div class="info-row">
            <strong>Aplicación:</strong>
            <span>{{ deploy.application_environment?.application?.name }}</span>
          </div>
          <div class="info-row">
            <strong>Entorno:</strong>
            <span>{{ deploy.application_environment?.role }}</span>
          </div>
          <div class="info-row">
            <strong>Branch:</strong>
            <span>{{ deploy.head_branch }}</span>
          </div>
          @if (deploy.tag) {
            <div class="info-row">
              <strong>Tag:</strong>
              <span>{{ deploy.tag }}</span>
            </div>
          }
          <div class="info-row">
            <strong>Estado:</strong>
            <mat-chip [class]="getStatusChipClass(deploy.status)">
              {{ getStatusLabel(deploy.status) }}
            </mat-chip>
          </div>
          <div class="info-row">
            <strong>Usuario responsable:</strong>
            <span>{{ deploy.user?.full_name || 'Desconocido' }}</span>
          </div>
          @if (deploy.started_at) {
            <div class="info-row">
              <strong>Iniciado:</strong>
              <span>{{ deploy.started_at | date: 'short' }}</span>
            </div>
          }
          @if (deploy.ended_at) {
            <div class="info-row">
              <strong>Finalizado:</strong>
              <span>{{ deploy.ended_at | date: 'short' }}</span>
            </div>
          }
          @if (deploy.product_tasks && deploy.product_tasks.length > 0) {
            <div class="info-row">
              <strong>Tareas deployadas:</strong>
              <div>
                @for (task of deploy.product_tasks; track task.id) {
                  <span class="task-code">{{ task.code }}</span>
                }
              </div>
            </div>
          }
          <div class="info-row">
            <strong>Enlace a GitHub:</strong>
            @if (getGithubUrl() !== '#') {
              <a [href]="getGithubUrl()" target="_blank"> Ver workflow run </a>
            } @else {
              <span>-</span>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}
